import { render, staticRenderFns } from "./MainPageViewer.vue?vue&type=template&id=6d519eca&scoped=true"
import script from "./MainPageViewer.vue?vue&type=script&lang=js"
export * from "./MainPageViewer.vue?vue&type=script&lang=js"
import style0 from "./MainPageViewer.vue?vue&type=style&index=0&id=6d519eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d519eca",
  null
  
)

export default component.exports